type State = {
    [key: string]:number
}

class StateService {    
    states:State = {}
    ls = window.localStorage;
    constructor() {
        if (process.env.NODE_ENV == "development") {}
        //this.ls.clear()
        if(this.ls.getItem("dashboard_state")){            
            this.states = JSON.parse(this.ls.getItem("dashboard_state") as string) as State   
        }        
    }

    InitState = (id:string): Promise<boolean>  => {
        if(this.states[id] == undefined){
            this.states[id] = 1            
        }

        return new Promise((resolve, reject) => {
            resolve(this.states[id] == 1? true:false)
        })
    }
    
    setState = (id:string, state:boolean) =>{
        this.states = {
            ...this.states,
            [id]:state?1:0
        }
        this.ls.setItem("dashboard_state", JSON.stringify(this.states))
    }
}


export default StateService